<artemis-breadcrumbs [breadcrumbs]="breadcrumbs"></artemis-breadcrumbs>
<artemis-customer-overview-card></artemis-customer-overview-card>
<div class="business-unit-card">
  <div ubi-curve-header class="business-unit-card__header">
    <span class="business-unit-card__header-text">DOMAIN ACCESS</span>
  </div>
  <artemis-popover>
    The Access Control allow users to share a case across to other domains (i.e. business units). By sharing the case across to other business units, it will allow the case to be editable by other business units.
  </artemis-popover>
  <div class="business-unit-card__content-container">
    <artemis-loading-spinner *ngIf="loading"></artemis-loading-spinner>
    <div class="business-unit-table__domains">
      <div class="business-unit-card__select-all">
        <mat-checkbox class="custom-mat-checkbox" [checked]="isAllSelected()" [indeterminate]="isIndeterminate()" (change)="selectAll($event)">
        </mat-checkbox>
        SELECT ALL DOMAINS
      </div>
      <span *ngFor="let domain of displayedDomains" class="business-unit-table__domains-cell uppercase-text">
        <mat-checkbox class="custom-mat-checkbox" [checked]="domain.checked" (change)="updateDomain(domain, $event)"></mat-checkbox>
        {{ domain.domainName }}
      </span>
    </div>
    <div class="business-unit-card__button-container" *ngIf="displayedDomains.length >= domainLimit">
      <ng-container *ngIf="!isShowAll">
        <button class="btn btn_rounded" mat-button ubi-round-button (click)="showAllDomains()">SHOW ALL</button>
      </ng-container>
      <ng-container *ngIf="isShowAll">
        <button class="btn btn_rounded" mat-button ubi-round-button (click)="showLessDomains()">SHOW LESS</button>
      </ng-container>
    </div>
  </div>
</div>
<div class="notification-card-container" #userNotificationsCard>
  <artemis-user-notifications-component (submitUpdatedNotificationList)="updateNotifications($event)" [takeDefaultUsers]="false"
                                        [allDomains]="customerDomains" [newDomain]="newDomain" [showActionButtons]="false">
  </artemis-user-notifications-component>
</div>
